import { useQuery } from 'react-query';
import HookTypes from '../redux/types/hooks';
import { getTopics } from '../redux/services/topicService';

const useHook = () => {
  return useQuery([HookTypes.topics], async () => {
    const response = await getTopics();
    return response;
  });
};

export default useHook;
